import { Group, Radio, RadioCardProps, Stack, Text } from '@mantine/core';
import { PropsWithChildren } from 'react';
import classes from './RadioBox.module.css';

interface Props {
  label: string;
  description?: string;
}

export const RadioBox = ({ description, label, children, ...props }: Props & RadioCardProps & PropsWithChildren) => {
  return (
    <Stack gap={'xs'}>
      <Radio.Card className={classes.root} {...props}>
        <Group wrap={'nowrap'} align={'flex-start'}>
          <Radio.Indicator />
          <Text className={!props.disabled && props.checked ? classes.labelBold : classes.label}>{label}</Text>
        </Group>
      </Radio.Card>
      <Stack gap={'xs'} ml={32}>
        {description && (
          <Text size={'sm'} data-testid={`radio-box-description`}>
            {description}
          </Text>
        )}
        {children}
      </Stack>
    </Stack>
  );
};
